import React from "react";
import styled from 'styled-components';
import { Button } from "react-bootstrap";
import classnames from "classnames";

interface ICtaButton  {
    ctaText: string;
    ctaHyperLink: string;
    className?: string;
    customClass: string;
}

export default styled((props: ICtaButton) => {

    const { ctaText, ctaHyperLink, className, customClass } = props;


    if (ctaText && ctaHyperLink) {
        return <Button 
            className={classnames("align-items-center btn btn-sm inverse py-1 px-3 my-1", className, customClass)}
            href={ctaHyperLink}>
                {ctaText}
            </Button>
    }

    return null;
})`

display: inline-flex;
font-size: .7rem;
text-transform: uppercase;
`;
